/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_ecocheck.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions EcoCheck */
(function() {
  var hfsEcoCheckSubscriptions = function (_me) {
    Hafas.ps.sub('/ecocheck/openEcoCheck', Hafas.bind(_me.Controller.ecocheck.openEcoCheck, _me));
    Hafas.ps.sub('/ecocheck/updateComplete', Hafas.bind(_me.Controller.ecocheck.updateResultTable, _me));
    Hafas.ps.sub('/ecocheck/errorResult', Hafas.bind(_me.Controller.ecocheck.showError, _me));
    Hafas.ps.sub('/ecocheck/update', Hafas.bind(_me.Controller.ecocheck.reRenderView, _me));
    Hafas.ps.sub('/ecocheck/close', Hafas.bind(_me.Controller.ecocheck.close, _me));
    Hafas.ps.sub('/ecocheck/openInfoPopup', Hafas.bind(_me.Controller.ecocheck.openInfoPopup, _me));
  }
  if (typeof HafasWebapp !== "undefined" && typeof HafasWebapp.prototype.subscriptions !== "undefined") {
    HafasWebapp.prototype.subscriptions.ecocheck = hfsEcoCheckSubscriptions;
  } else {
    HafasWebview.prototype.subscriptions.ecocheck = hfsEcoCheckSubscriptions;
  }
}());

